import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import ParticipantsV2Store from '../../Store';
import EmptyState from './EmptyState';
import ErrorRow from './ErrorRow';
import LoadingRows from './LoadingRows';
import Row from './Row';

interface Props {
  store: ParticipantsV2Store;
}

function Body({ store }: Props) {
  switch (store.state.kind) {
    case 'loading':
      return <LoadingRows />;
    case 'error':
      return <ErrorRow message={store.state.message} />;
    case 'ready': {
      const { participants } = store.state.resource.payload;
      return (
        <tbody>
          {participants.length > 0 ? (
            participants.map((resource) => (
              <Row key={resource.payload.id} participant={resource.payload} />
            ))
          ) : (
            <EmptyState store={store} />
          )}
        </tbody>
      );
    }
    default:
      return assertNever(store.state);
  }
}

export default observer(Body);
